export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.23-1042.48",
  commitId: "481dabb98059b91eef3025d6a8c071232598b179",
  commitTime: "2026-04-23T10:42:48.000Z",
});
